import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import LeftArrowSvg from '../../svg/student/Left.js';
import RightArrowSvg from '../../svg/student/Right.js';
import Timer from './components/Timer.js';

function Component(props) {
    const { } = useParams();
    const navigate = useNavigate();
    const [data, setdata] = useState(null)
    const [isLoading, setisLoading] = useState(false)
    const isMobile = window.innerWidth <= 1024


    const fetchData = async (force = false) => {
        if (isLoading && !force) return
        setisLoading(true)
        // let result = await fetchWordById(props.token.token,id);
        // if(result.result){
        //     setdata(result.result)
        // }else{
        //     alert('Fetch data error')
        // }
        setisLoading(false)
    }
    useEffect(() => {
        fetchData();
    }, [])

    const close = () => {
        if (props.close) props.close()
    }

    const scrollRef1 = useRef(null)
    const scrollRef2 = useRef(null)
    const scrollRef3 = useRef(null)
    const scrollRef4 = useRef(null)


    return (
        <div className='fixed w-[100vw] h-[100vh] top-0 left-0 bg-[white] flex flex-col gap-[32px] py-[32px]  text-black z-[3]' style={{ overflowY: 'auto', border: isMobile?  '3px solid rgb(153,205,255)': '15px solid rgb(153,205,255)',paddingLeft: isMobile? '8px':'64px',paddingRight: isMobile? '8px':'64px',paddingTop: isMobile? '8px':'32px',paddingBottom: isMobile? '8px':'32px' }}>
            <div ref={scrollRef1} className='font-[700] text-[32px]'>説明</div>
            <div className=' flex flex-col' style={{ fontSize:isMobile?18:18,display: "inline-block" }}>
                以下你可以找到有關本測試及作答的指引。<br />
                請點擊任何一條連結或向下捲動，尋找你所需要的指引。<br />
                當你完成後，點擊 <div onClick={close} className='text-[blue] underline cursor-pointer' style={{ display: "inline-block" }}>關閉</div> 來返回測試畫面。<br />
            </div>

            <div className='font-[700] flex flex-col' style={{ display: "inline-block" ,fontSize:isMobile?18:22}}>
                <div onClick={()=>{scrollRef2.current.scrollIntoView()}} className='text-[blue] underline cursor-pointer'>在測試之中移動及追查進度</div>
                <div onClick={()=>{scrollRef3.current.scrollIntoView()}} className='text-[blue] underline cursor-pointer'>如何作答</div>
                <div onClick={()=>{scrollRef4.current.scrollIntoView()}} className='text-[blue] underline cursor-pointer'>在頁面之間移動</div>
            </div>

            <div onClick={close} className='text-[18px] text-[blue] underline cursor-pointer' style={{ display: "inline-block" }}>關閉</div>

            {/* section 1*/}
            <div ref={scrollRef2} className='w-full flex flex-col' style={{border:'1px solid black',fontSize:isMobile?16:20}}>
                <div className='font-[700] text-white p-[16px] w-full text-center bg-[rgb(139,139,139)]' style={{border:'1px solid black',fontSize:isMobile?26:32}}>在測試之中移動及追查進度</div>
                <div className='flex flex-row w-full items-stretch'>
                    <div className='w-[180px] bg-[rgb(79,129,188)] flex flex-col items-center justify-center p-[16px]' style={{border:'1px solid black'}}>
                        <div className='h-[48px] w-[48px] rounded-[7px] bg-[#C3E9FF] flex justify-center items-center cursor-pointer hover:opacity-[0.8]'>
                            <LeftArrowSvg width={36} height={36}/>
                        </div>
                    </div>
                    <div className='flex-1 bg-[white] p-[16px] flex-col items-start justify-center' style={{border:'1px solid black',display:'inline-block'}}>
                        <b>• </b>點擊「下一頁」的箭號來移至下一條問題或下一個單元。
                    </div>
                </div>
                <div className='flex flex-row w-full items-stretch'>
                    <div className='w-[180px] bg-[rgb(79,129,188)] flex flex-col items-center justify-center p-[16px]' style={{border:'1px solid black'}}>
                        <div className='h-[48px] w-[48px] rounded-[7px] bg-[#C3E9FF] flex justify-center items-center cursor-pointer hover:opacity-[0.8]'>
                            <RightArrowSvg width={36} height={36}/>
                        </div>
                    </div>
                    <div className='flex-1 bg-[white] p-[16px]  flex-col items-start justify-center' style={{border:'1px solid black',display:'inline-block'}}>
                        <b>• </b>點擊「上一頁」的箭號來返回上一條問題。<br/>
                        <b>• </b>如果你不能返回，箭號會變為灰色。
                    </div>
                </div>
                <div className='flex flex-row w-full items-stretch'>
                    <div className='w-[180px] bg-[rgb(79,129,188)] flex flex-col items-center justify-center p-[16px]' style={{border:'1px solid black'}}>
               
                        <div className='bg-[#C3E9FF] flex flex-row p-[6px] gap-[6px]'>
                            {[1,2,3,4]?.map((item, index) =>
                                <div key={item} className='h-[36px] w-[27px] cursor-pointer flex flex-row justify-center items-center font-[700]' style={{  backgroundColor: index === 1 ? '#1F4CC8' : index<=1?'#00E9BA':'white', border: '2px solid #D9D9D9' }}>
                                    {/* {index + 1} */}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className='flex-1 bg-[white] p-[16px]  flex-col items-start justify-center' style={{border:'1px solid black',display:'inline-block'}}>
                        <b>• </b>進度棒內的每個正方形代表一個單元。一個單元是一組基於相同材料的問題。<br/>
                        <b>• </b>當你完成一個單元後，該正方形會變為深綠色。<br/>
                        <b>• </b>白色正方形顯示你正在進行測試的單元。
                    </div>
                </div>
                <div className='flex flex-row w-full items-stretch'>
                    <div className='w-[180px] bg-[rgb(79,129,188)] flex flex-col items-center justify-center p-[16px]' style={{border:'1px solid black'}}>
                        <Timer text={'20:00'} percentage={25}/>
                    </div>
                    <div className='flex-1 bg-[white] p-[16px]  flex-col items-start justify-center' style={{border:'1px solid black',display:'inline-block'}}>
                        <b>• </b>你將會有 20 分鐘去完成每一段測試。<br/>
                        <b>• </b>隨着時間過去，圓圈會填上深綠色，來顯示你還餘下多少時間來作答這一段測試。
                    </div>
                </div>
            </div>

            <div className='w-full flex flex-row gap-[24px] text-'>
                <div onClick={()=>{scrollRef1.current.scrollIntoView()}} className='text-[18px] text-[blue] underline cursor-pointer' style={{ display: "inline-block" }}>⇑ 回到最上面</div>
                <div onClick={close} className='text-[18px] text-[blue] underline cursor-pointer' style={{ display: "inline-block" }}>關閉</div>
            </div>


            {/* section 2*/}
            <div ref={scrollRef3} className='w-full flex flex-col text-[20px]' style={{border:'1px solid black'}}>
                <div className='font-[700] text-[32px] text-white p-[16px] w-full text-center bg-[rgb(139,139,139)]' style={{border:'1px solid black'}}>如何作答</div>
                <div className='flex flex-row w-full items-stretch'>
                    <div className='w-[180px] bg-[rgb(217,217,217)] flex flex-col items-center justify-start p-[16px]' style={{border:'1px solid black'}}>
                        <img style={{width:'70%',objectFit:'contain'}} src={'/images/i1.png'}/>
                    </div>
                    <div className='flex-1 bg-[white] p-[16px]  flex-col items-start justify-center' style={{border:'1px solid black',display:'inline-block'}}>
                        <b>點擊一個選項： </b> 這類問題只有一個答案。<br/>
                        <b>• </b>點擊你的選項，該圓圈會被填滿。<br/>
                        <b>• </b>更改你的答案時，點擊另一個選項。
                    </div>
                </div>
                <div className='flex flex-row w-full items-stretch'>
                    <div className='w-[180px] bg-[rgb(217,217,217)] flex flex-col items-center justify-start p-[16px]' style={{border:'1px solid black'}}>
                        <img style={{width:'70%',objectFit:'contain'}} src={'/images/i2.png'}/>
                    </div>
                    <div className='flex-1 bg-[white] p-[16px]  flex-col items-start justify-center' style={{border:'1px solid black',display:'inline-block'}}>
                        <b>點擊一個或多個方格： </b> 這類問題可能有多於一個答案。<br/>
                        <b>• </b>點擊一個或多個方格，每個已選擇的方格內會出現一個標記。<br/>
                        <b>• </b>更改你的答案時，再次點擊你已選擇的方格，標記會被消除。
                    </div>
                </div>
                <div className='flex flex-row w-full items-stretch'>
                    <div className='w-[180px] bg-[rgb(217,217,217)] flex flex-col items-center justify-start p-[16px]' style={{border:'1px solid black'}}>
                        <img style={{width:'70%',objectFit:'contain'}} src={'/images/i3.png'}/>
                    </div>
                    <div className='flex-1 bg-[white] p-[16px]  flex-col items-start justify-center' style={{border:'1px solid black',display:'inline-block'}}>
                        <b>點擊一個圖表或一張圖片：</b><br/>
                        <b>• </b>點擊一個圖表或一張圖片時，它會被突顯出來。<br/>
                        <b>• </b>更改你的答案時，再次點擊圖表或圖片，它會回復原狀。
                    </div>
                </div>
                <div className='flex flex-row w-full items-stretch'>
                    <div className='w-[180px] bg-[rgb(217,217,217)] flex flex-col items-center justify-start p-[16px]' style={{border:'1px solid black'}}>
                        <img style={{width:'70%',objectFit:'contain'}} src={'/images/i4.png'}/>
                    </div>
                    <div className='flex-1 bg-[white] p-[16px]  flex-col items-start justify-center' style={{border:'1px solid black',display:'inline-block'}}>
                        <b>輸入答案：</b><br/>
                        <b>• </b>在方格內點擊一下，然後輸入答案。<br/>
                        <b>• </b>使用退格鍵 (Backspace) 來刪除答案
                    </div>
                </div>
                <div className='flex flex-row w-full items-stretch'>
                    <div className='w-[180px] bg-[rgb(217,217,217)] flex flex-col items-center justify-start p-[16px]' style={{border:'1px solid black'}}>
                        <img style={{width:'70%',objectFit:'contain'}} src={'/images/i5.png'}/>
                    </div>
                    <div className='flex-1 bg-[white] p-[16px]  flex-col items-start justify-center' style={{border:'1px solid black',display:'inline-block'}}>
                        <b>使用數字鍵來輸入答案：</b><br/>
                        你 <b>不能</b> 使用鍵盤上的字母鍵來作答這類問題。你需要使用數字鍵及以下五個鍵來輸入答案。<br/>
                        <b>• </b>逗號 [ ， ]<br/>
                        <b>• </b>小數點 [ . ]<br/>
                        <b>• </b>表示分數的斜線 [ / ]<br/>
                        <b>• </b>表示負值的橫線 [ - ]<br/>
                        <b>• </b>空白鍵
                    </div>
                </div>
                <div className='flex flex-row w-full items-stretch'>
                    <div className='w-[180px] bg-[rgb(217,217,217)] flex flex-col items-center justify-start p-[16px]' style={{border:'1px solid black'}}>
                        <img style={{width:'70%',objectFit:'contain'}} src={'/images/i6.png'}/>
                    </div>
                    <div className='flex-1 bg-[white] p-[16px]  flex-col items-start justify-center' style={{border:'1px solid black',display:'inline-block'}}>
                        <b>使用下拉式選單： </b><br/>
                        <b>• </b>在箭號上點擊並按住滑鼠按鈕。<br/>
                        <b>• </b>繼續按住按鈕並移動滑鼠來選擇一個選項。<br/>
                        <b>• </b>放開滑鼠按鈕，你所選擇的選項會在選單的頂部顯示出來。<br/>
                        <b>• </b>更改你的答案時，重覆以上步驟來選擇另一個選項。
                    </div>
                </div>
                <div className='flex flex-row w-full items-stretch'>
                    <div className='w-[180px] bg-[rgb(217,217,217)] flex flex-col items-center justify-start p-[16px]' style={{border:'1px solid black'}}>
                        <img style={{width:'70%',objectFit:'contain'}} src={'/images/i7.png'}/>
                    </div>
                    <div className='flex-1 bg-[white] p-[16px]  flex-col items-start justify-center' style={{border:'1px solid black',display:'inline-block'}}>
                        <b>使用「拖放」功能： </b><br/>
                        <b>• </b>點擊你想拖動的物件。<br/>
                        <b>• </b>繼續按着滑鼠按鈕，然後把物件拖至目標位置。<br/>
                        <b>• </b>放開滑鼠按鈕後，物件會在所選擇的位置出現。<br/>
                        <b>• </b>更改你的答案時，把物件拖動至原來位置。
                    </div>
                </div>
            </div>
            <div className='w-full flex flex-row gap-[24px] text-'>
                <div onClick={()=>{scrollRef1.current.scrollIntoView()}} className='text-[18px] text-[blue] underline cursor-pointer' style={{ display: "inline-block" }}>⇑ 回到最上面</div>
                <div onClick={close} className='text-[18px] text-[blue] underline cursor-pointer' style={{ display: "inline-block" }}>關閉</div>
            </div>

            {/* section 3*/}
            <div ref={scrollRef4} className='w-full flex flex-col text-[20px]' style={{border:'1px solid black'}}>
                <div className='font-[700] text-[32px] text-white p-[16px] w-full text-center bg-[rgb(139,139,139)]' style={{border:'1px solid black'}}>在頁面之間移動</div>
                <div className='flex flex-col w-full items-center py-[16px]' style={{border:'1px solid black'}}>
                    <img style={{width:'500px', maxWidth:'80%',objectFit:'contain'}} src={'/images/i8.png'}/>

                    <div className='w-full bg-[white] p-[16px]  flex-col items-start justify-center' style={{display:'inline-block'}}>
                        <b>在頁面之間移動：</b> 某些單元會包含多於一頁的閱讀材料。<br/>
                        <b>• </b>點擊頁數來在頁面之間移動。<br/>
                        <b>• </b>在每條問題，第1頁會首先顯示出來。<br/>
                        <b>• </b>你可以隨時在一個單元內的不同頁面之間來回。
                    </div>
                </div>
            </div>

            <div className='w-full flex flex-row gap-[24px] text-'>
                <div onClick={()=>{scrollRef1.current.scrollIntoView()}} className='text-[18px] text-[blue] underline cursor-pointer' style={{ display: "inline-block" }}>⇑ 回到最上面</div>
                <div onClick={close} className='text-[18px] text-[blue] underline cursor-pointer' style={{ display: "inline-block" }}>關閉</div>
            </div>

        </div>
    );
}

export default connect((store) => {
    return {
        token: store.tokenReducer,
    }
})(Component)
